export enum SectorState {
    DISCONNECTED = "DISCONNECTED",
    NO_IRRIG = "NO_IRRIG",
    START_IRRIG = "START_IRRIG",
    IRRIG = "IRRIG",
    INCIDENCE = "INCIDENCE",
    MALFUNCTION = "MALFUNCTION",
    WAIT_WATER = "WAIT_WATER",
    LEAK = "LEAK",
    IRRIGATION_ALLOCATION = "IRRIGATION_ALLOCATION",
    UNKNOWN = "UNKNOWN"
}

export enum SectorMode {
    AUTOMATIC = "AUTOMATIC",
    MANUAL = "MANUAL"
}

export enum SectorType {
    ISOLATED = "ISOLATED",
    SELF_SECTORIZED = "SELF_SECTORIZED",
    SECTORIZED = "SECTORIZED",
    SECTOR = "SECTOR"
}

export enum SectorManualActionsPermission {
    NONE = "NONE",
    BASIC = "BASIC",
    FULL = "FULL"
}

export enum SectorStateReason {
    NONE="NONE",
    TEMPORARY_BY_CONTROL="TEMPORARY_BY_CONTROL",
    CONDITIONAL_BY_CONTROL_OR_FUNCTION="CONDITIONAL_BY_CONTROL_OR_FUNCTION",
    LIMIT_HYDRANT="LIMIT_HYDRANT",
    LIMIT_NETWORK="LIMIT_NETWORK",
    LIMIT_ALLOCATION="LIMIT_ALLOCATION",
    LIMIT_BALANCE="LIMIT_BALANCE",
    LIMIT_SCHEDULE="LIMIT_SCHEDULE",

    FLOW_CONFIGURATION="FLOW_CONFIGURATION",
    HYDRANT_SECTORS="HYDRANT_SECTORS",
    SECTORS_SEGMENT="SECTORS_SEGMENT",
    METER_FLOW="METER_FLOW",
    ELEMENT_FAILURE="ELEMENT_FAILURE",
    IRRIGATION_ALLOCATION_EXCEEDED="IRRIGATION_ALLOCATION_EXCEEDED",
    SCHEDULE="SCHEDULE",
    METER_IN_USE="METER_IN_USE",
    SYSTEM_DEF_STOP="SYSTEM_DEF_STOP",
    SYSTEM_CONDITIONAL_STOP="SYSTEM_CONDITIONAL_STOP",
    OUT_OF_SERVICE_DEVICE="OUT_OF_SERVICE_DEVICE",
    SECTOR_OUT_OF_SERVICE="SECTOR_OUT_OF_SERVICE",
    DEF_STOP_BY_CONTROL_OR_FUNCTION="DEF_STOP_BY_CONTROL_OR_FUNCTION"
}